import { useMemo, useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import EmptyState from "@/components/base/EmptyState";
import Pagination from "@/components/base/Pagination";
import { useSeo } from "@/hooks/useSeo";
import { getByCategory, paginate, sortContent, type SortKey } from "@/lib/content";
import { getCategoryMeta } from "@/mocks/categories";
import CategoryHeader from "@/pages/category/components/CategoryHeader";
import SortTabs from "@/pages/category/components/SortTabs";
import NewsListCard from "@/pages/category/components/NewsListCard";

const meta = getCategoryMeta("entertainment-news")!;
const PAGE_SIZE = 6;

const sortOptions = [
  { key: "date-desc", label: "最新发布" },
  { key: "date-asc", label: "最早发布" },
  { key: "heat-desc", label: "热度最高" },
];

export default function EntertainmentNewsPage() {
  const [sort, setSort] = useState<SortKey>("date-desc");
  const [page, setPage] = useState(1);

  useSeo({
    title: "娱乐新闻 - 红桃网",
    description:
      "红桃网娱乐新闻频道，网罗华语与海外娱乐圈热点，明星动态、综艺资讯、红毯盛典与行业花絮一网打尽。",
    keywords: "娱乐新闻,明星动态,综艺资讯,红桃网",
  });

  const result = useMemo(() => {
    const list = sortContent(getByCategory("entertainment-news"), sort);
    return paginate(list, page, PAGE_SIZE);
  }, [sort, page]);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <main className="flex-1 w-full">
        <CategoryHeader meta={meta} />
        <div className="w-full px-4 md:px-8 py-6 md:py-8">
          <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
            <SortTabs
              options={sortOptions}
              value={sort}
              onChange={(k) => {
                setSort(k as SortKey);
                setPage(1);
              }}
            />
            <span className="text-sm text-foreground-500">
              共 {result.total} 条新闻
            </span>
          </div>

          {result.items.length === 0 ? (
            <EmptyState message="暂无相关娱乐新闻，您可以尝试调整筛选条件。" />
          ) : (
            <div className="space-y-4">
              {result.items.map((item) => (
                <NewsListCard key={item.id} item={item} categoryLabel="娱乐新闻" />
              ))}
            </div>
          )}

          <Pagination page={result.page} totalPages={result.totalPages} onChange={setPage} />
        </div>
      </main>
      <Footer />
    </div>
  );
}